import axios from "axios";

async function getAddressOfCoordinates(lat, lng) {
  const response = await axios.get(
    "https://api.opencagedata.com/geocode/v1/json? ",
    {
      params: {
        key: "103fda4edfee402fa23d1d1e4d742132",
        q: `${lat}+${lng}`,
        language: "en",
      },
    }
  );

  return response;
}

export default getAddressOfCoordinates;
